export default __webpack_public_path__ + "static/media/sunset-paywall-header.5f2f7436.png";